var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',_vm._b({class:_vm.data.staticClass || ''},'svg',_vm.data.attrs,false),[_c('use',{attrs:{"xlink:href":'#' + _vm.props.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }